// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.
export default [
    {
        path: '/:organisation/payables/purchase-orders',
        component: () => import('@/pages/[organisation]/payables/purchase-orders.vue'),
        name: 'accounts-payable.purchase-orders.search-purchase-orders',
        meta: {
            loginRequired: true,
            permission: 'access.payables.purchase-order.view-purchase-orders',
        },
        children: [
            {
                path: 'create-purchase-order',
                component: () => import('@/pages/[organisation]/payables/purchase-orders/create-purchase-order.vue'),
                name: 'accounts-payable.purchase-orders.create-purchase-order',
                meta: {
                    loginRequired: true,
                    permission: 'access.payables.purchase-order.create-purchase-order',
                },
            },
            {
                path: ':id',
                component: () => import(/* webpackChunkName: "accounts-payable.purchase-orders" */ '@/pages/[organisation]/payables/purchase-orders/purchase-order/[id].vue'),
                name: 'accounts-payable.purchase-orders.view-purchase-order',
                meta: {
                    loginRequired: true,
                    permission: 'access.payables.purchase-order.view-purchase-orders',
                },
            },
            {
                path: ':id/edit',
                component: () => import(/* webpackChunkName: "accounts-payable.purchase-orders" */ '@/pages/[organisation]/payables/purchase-orders/purchase-order/[id]/edit.vue'),
                name: 'accounts-payable.purchase-orders.update-purchase-order',
                meta: {
                    loginRequired: true,
                    permission: 'access.payables.purchase-order.update-purchase-order',
                },
            },
            {
                path: ':id/history',
                component: () => import(/* webpackChunkName: "accounts-payable.purchase-orders" */ '@/pages/[organisation]/payables/purchase-orders/purchase-order-history.vue'),
                name: 'accounts-payable.purchase-orders.view-purchase-order-history',
                meta: {
                    loginRequired: true,
                    permission: 'access.payables.purchase-order.view-purchase-orders',
                },
            },
            {
                path: ':id/receive-items',
                component: () => import(/* webpackChunkName: "accounts-payable.purchase-orders" */ '@/pages/[organisation]/payables/purchase-orders/receive-purchase-order-items.vue'),
                name: 'accounts-payable.purchase-orders.receive-purchase-order-items',
                meta: {
                    loginRequired: true,
                    permission: 'access.payables.purchase-order.update-purchase-order',
                },
            },
            {
                path: ':id/add-bill',
                component: () => import(/* webpackChunkName: "accounts-payable.purchase-orders" */ '@/pages/[organisation]/payables/purchase-orders/purchase-order-bill/new.vue'),
                name: 'accounts-payable.purchase-orders.create-purchase-order-bill',
                meta: {
                    loginRequired: true,
                    permission: 'access.payables.expense.create-draft-expense',
                },
            },
            {
                path: ':id/apply-landed-cost',
                component: () => import(/* webpackChunkName: "accounts-payable.purchase-orders" */ '@/pages/[organisation]/payables/purchase-orders/apply-landed-cost.vue'),
                name: 'accounts-payable.purchase-orders.apply-landed-cost',
                meta: {
                    loginRequired: true,
                    // Same ability as the import bill: both capitalise a cost into the goods.
                    permission: 'access.payables.purchase-order.create-import-bill',
                },
            },
            {
                path: ':id/add-import-bill',
                component: () => import(/* webpackChunkName: "accounts-payable.purchase-orders" */ '@/pages/[organisation]/payables/purchase-orders/import-bill/new.vue'),
                name: 'accounts-payable.purchase-orders.create-import-bill',
                meta: {
                    loginRequired: true,
                    permission: 'access.payables.purchase-order.create-import-bill',
                },
            },
        ],
    },
];
